import apisauce from "apisauce";
import { getBaseApiURL } from "common/helper";
import { NO_CACHE_HEADERS } from "constants/headers";

var Singleton = (function () {
    var instance;

    function createInstance() {
        return apisauce.create({
            baseURL: getBaseApiURL(),
            cache: "no-store",
            headers: {
                ...NO_CACHE_HEADERS,
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            timeout: 150000,
        });
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();

export default Singleton.getInstance();
